import { render, staticRenderFns } from "./AccessUpdateDialog.vue?vue&type=template&id=2dcd0758&scoped=true"
import script from "./AccessUpdateDialog.vue?vue&type=script&lang=js"
export * from "./AccessUpdateDialog.vue?vue&type=script&lang=js"
import style0 from "./AccessUpdateDialog.vue?vue&type=style&index=0&id=2dcd0758&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcd0758",
  null
  
)

export default component.exports